import { Suspense, useEffect, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { TooltipProvider } from './components/ui/tooltip';
import { Pages } from './constants/pages';
import { ChatScreen } from './pages/chat';
import ChatProvider from './stores/providers/chat-provider';
import ConversationProvider from './stores/providers/conversation-provider';
import ThemeProvider from './stores/providers/theme-provider';
import '@iframe-resizer/child';
import './styles/index.css';

const ConsentPage = lazy(() => import('./pages/disclaimer/consent-page'));
const NotFoundPage = lazy(() => import('./pages/not-found/not-found-page'));
const PdfViewerScreen = lazy(() => import('./pages/pdf-viewer/pdf-viewer'));
const TopicPickerPage = lazy(() => import('./pages/topic-picker/topic-picker-page'));
const VideoViewerScreen = lazy(() => import('./pages/video-viewer/video-viewer'));

function App() {
  const { t } = useTranslation();

  useEffect(() => {
    window.iFrameResizer = {
      onReady: () => console.info('iframe-resizer is ready'),
    } as Record<string, unknown>;
  }, []);

  useEffect(() => {
    document.title = t('common.document_title');
  }, [t]);

  return (
    <ThemeProvider>
      <ConversationProvider>
        <ChatProvider>
          <TooltipProvider>
            <Suspense fallback={<div className="p-4 text-sm">Laden...</div>}>
              <Routes>
                <Route path="/instance/:instance" element={<ChatScreen />} />
                <Route
                  path={`/instance/:instance${Pages.PDFViewer}/:docId`}
                  element={<PdfViewerScreen />}
                />
                <Route
                  path={`/instance/:instance${Pages.VideoViewer}/:docId`}
                  element={<VideoViewerScreen />}
                />
                <Route path={`${Pages.PDFViewer}/:docId`} element={<PdfViewerScreen />} />
                <Route path={`${Pages.VideoViewer}/:docId`} element={<VideoViewerScreen />} />
                <Route path={Pages.Chat} element={<ChatScreen />} />
                <Route path={Pages.Disclaimer} element={<ConsentPage />} />
                <Route path={Pages.TopicPicker} element={<TopicPickerPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </TooltipProvider>
        </ChatProvider>
      </ConversationProvider>
    </ThemeProvider>
  );
}

export default App;
